import clsx from "clsx";
import React from "react";

type Props = { value: boolean; onClick?: () => void; className?: string };

export default function CommonRadio({ value, onClick, className }: Props) {
  return (
    <div onClick={onClick} className={clsx(["transition-all", className])}>
      {value ? <DefaultSelectRadio /> : <DefaultUnSelectRadio />}
    </div>
  );
}

export const DefaultSelectRadio = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2.9502"
      y="3.48846"
      width="19"
      height="19"
      rx="9.5"
      stroke="black"
    />
    <rect x="7.4502" y="7.98846" width="10" height="10" rx="5" fill="black" />
  </svg>
);

export const DefaultUnSelectRadio = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2.9502"
      y="3.48846"
      width="19"
      height="19"
      rx="9.5"
      stroke="#868687"
    />
  </svg>
);
